export default {"src":"/_next/static/media/arrow-elbow-down-left.fbe5a396.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};